import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ContentProvider } from "@/context/ContentContext";
import SmoothScroll from "@/components/SmoothScroll";
import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";

import Home from "@/pages/Home";
import Doors from "@/pages/Doors";
import Windows from "@/pages/Windows";
import Cases from "@/pages/Cases";
import CaseDetail from "@/pages/CaseDetail";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Energiforbedring from "@/pages/landing/Energiforbedring";
import DesignAestetik from "@/pages/landing/DesignAestetik";
import Privatlivspolitik from "@/pages/Privatlivspolitik";
import Cookiepolitik from "@/pages/Cookiepolitik";
import NotFound from "@/pages/NotFound";
import Login from "@/pages/admin/Login";
import Dashboard from "@/pages/admin/Dashboard";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <ContentProvider>
            <SmoothScroll>
              <Routes>
                {/* Public site */}
                <Route element={<Layout />}>
                  <Route path="/" element={<Home />} />
                  <Route path="/doere" element={<Doors />} />
                  <Route path="/vinduer" element={<Windows />} />
                  <Route path="/cases" element={<Cases />} />
                  <Route path="/cases/:slug" element={<CaseDetail />} />
                  <Route path="/om-os" element={<About />} />
                  <Route path="/kontakt" element={<Contact />} />
                  {/* Hidden Google Ads landing pages (not in menu) */}
                  <Route path="/lp/energiforbedring" element={<Energiforbedring />} />
                  <Route path="/lp/design-aestetik" element={<DesignAestetik />} />
                  {/* Legal */}
                  <Route path="/privatlivspolitik" element={<Privatlivspolitik />} />
                  <Route path="/cookiepolitik" element={<Cookiepolitik />} />
                  {/* 404 catch-all */}
                  <Route path="*" element={<NotFound />} />
                </Route>

                {/* Admin */}
                <Route path="/admin/login" element={<Login />} />
                <Route path="/admin" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
              </Routes>
            </SmoothScroll>
          </ContentProvider>
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="top-center" />
    </div>
  );
}

export default App;
